// Wireminds eTracking

/**
 * trackingScript():
 * Contains the specified script for WiredMinds.
 *
 * initTracking():
 * Convert tracking script into a string and replace all placeholder vars.
 * Insert string to the end of the body.
 *
 * Parameter data is taken from 'window.bawu' from the page head:
 * $WM_PAGE_NAME => window.bawu.WIREDMINDS_PAGENAME
 * $WM_GROUP_NAME => window.bawu.WIREDMINDS_GROUPNAME
 * $WM_ID => window.bawu.WIREDMINDS_URL
 *
 */

/* eslint-disable */
const trackingScript = (wmGroupName, wmPageName, wmUrl) => {
  /* Start own parameters */
  console.log('trackingScript')
  var wiredminds = wiredminds || [];
  // wiredminds.push(["setTrackParam", "wm_custnum", "b85c3e0539880114"]);
  wiredminds.push(['setTrackParam', 'wm_page_name', wmPageName]);
  wiredminds.push(['setTrackParam', 'wm_group_name', wmGroupName]);
  // wiredminds.push(["count"]);
  /* End own parameters */
  (function(d, s) {
    var l = d.createElement(s),
      e = d.getElementsByTagName(s)[0];
    l.async = true;
    l.type = 'text/javascript';
    l.src = wmUrl;
    e.parentNode.insertBefore(l, e);
  })(document, 'script');
}
/* eslint-enable */

const initTracking = () => {
  // const wmGroupName = 'groupName';
  // const wmPageName = 'pageName';
  // const wmUrl = 'test.com';
  const wmGroupName = window.bawu.WIREDMINDS_GROUPNAME || null;
  const wmPageName = window.bawu.WIREDMINDS_PAGENAME || null;
  const wmUrl = window.bawu.WIREDMINDS_URL || null;

  if (wmGroupName && wmPageName && wmUrl) {
    /* eslint-disable-next-line */
    // const trackingScriptString = trackingScript + '';
    /* eslint-disable-next-line */
    // const trackingScriptBody = trackingScriptString.slice(trackingScriptString.indexOf('{') + 1, trackingScriptString.lastIndexOf('}'));

    // Replace page specific variables in the tracking script
    /* eslint-disable-next-line */
    // const $clone = trackingScriptBody.replace('$WM_PAGE_NAME', wmPageName).replace('$WM_GROUP_NAME', wmGroupName).replace('$WM_URL', wmUrl);

    // Place the script inside the body
    trackingScript(wmGroupName, wmPageName, wmUrl);
  }
};

initTracking();


export default initTracking;
